module.exports = __webpack_public_path__ + "static/media/img_14.5573dd33.png";